/* eslint-disable no-alert */
import UserTable from "./components/UserTable"
import { useState, useEffect } from 'react'
import { useTranslation, withTranslation } from "react-i18next"
import React from "react";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import TablePagination from "common/components/TablePagination";
import useThrowAsyncError from "common/hooks/useThrowAsyncError";
import { useFlashMessages } from "common/contexts/FlashMessages";
import { useAuthentication } from "common/contexts/Authentication";
import { getAll, remove, createOrUpdate } from './services/UserService';
import UserEditForm from "./components/UserForm";
import PageTitle from "common/components/PageTitle";

const config = window.userManagementConfig.ui;


const empty = Object.freeze({
  name: '',
  username: '',
  password: '',
  email: '',
  roles: [],
});

const UserManagement = () => {

  let { path } = useRouteMatch();
  const throwAsyncError = useThrowAsyncError();
  const { flashMessages, addFlashMessage } = useFlashMessages();
  const authentication = useAuthentication();
  const { t } = useTranslation('userManagement');
  const history = useHistory();

  const [ search, setSearch ] = useState('');
  const [ currentData, setCurrentData ] = useState([]);
  const [model, setModel] = useState({ ...empty });
  const [item, setItem] = useState({});
  const [saved, setSaved] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [result, setResult] = useState({
    items: [],
    page: 0,
    totalPageCount: 0,
  });

  const availableRoles = config.roles.options(t);

  const gotoEdit = (item) => {

    if (item) {
      setModel(item);
    } else {
      setModel(empty);
    }

    const uuid = item && item.uuid ? item.uuid : 'new';
    history.push(`${path}/${uuid}`);
  };

  const gotoList = () => {
    clearItem();
    history.push(`${path}`);
  };

  const clearItem = () => {
    setItem({ ...empty });
  };


  useEffect(() => {
    console.info('Get vouchers');

    getAll(authentication.getMerchantUuid(), currentPage > 0 ? currentPage - 1 : currentPage).then((result) => {
      setResult(result);
    }).catch(e => console.log(e));

  }, [saved, currentPage]);

  useEffect(() => {
    setCurrentData(result.items);
  }, [ result ]);

  const handleRemove = async (item) => {
    // eslint-disable-next-line no-restricted-globals
    // eslint-disable-next-line no-alert
    // eslint-disable-next-line no-restricted-globals
    if (confirm(t('messages.confirm.removal', { name: item.name }))) {

      try {
        await remove(authentication.getMerchantUuid(), item);
        setSaved(item);
        addFlashMessage({ variant: 'success', text: 'common:remove.succeeded' });
      } catch (e) {
        addFlashMessage({ variant: 'danger', text: 'common:remove.failed' });
      }
    }
  };

  const handleChange = (name, value) => {
    let update = { ...model };


    if (!Array.isArray(value) && typeof value === 'object') {
      if (name) {
        update[name] = { ...update[name], ...value };
      } else {
        update = { ...update, ...value };
      }
    } else {
      update[name] = value;
    }

    setModel(update);
  };

  const handleSubmit = async () => {
    try {
      await createOrUpdate(authentication.getMerchantUuid(), model);
      addFlashMessage({ variant: 'success', text: 'common:messages.save.succeeded' });
      setSaved(model);
      gotoList();
    } catch (e) {
      addFlashMessage({ variant: 'danger', text: 'common:messages.save.failed' });
    }
  };

  function autocompleteMatch(input) {
    if (input === '') {
      setCurrentData(result.items);
    };
    const reg = new RegExp(input.toLowerCase());
    setCurrentData(result.items.filter((term) => {
      if (term.name.toLowerCase().match(reg)) {
        return term;
      }
      return null;
    }));
  };

  useEffect(() => {
    autocompleteMatch(search);
  }, [ search ]);


  return (
    <section>
      <Switch>
        <Route exact path={path}>

          <PageTitle t={t} />
          <div className="yoso-table bg-white">
            <div className="row mb-2 table-header">
              <div className="col-10"></div>
              <div className="text-end">
                <input placeholder='Search' value={search} onInput={(e) => { setSearch(e.target.value); }} />
                <a onClick={(e) => { e.preventDefault(); gotoEdit(); }} className="btn btn-primary">
                  {t('common:actions.add', { 'object': t('user.singular') })}
                </a>
              </div>
            </div>
            <div className="table-body">
              <UserTable t={t} data={currentData} onItemRemove={handleRemove} onItemEdit={gotoEdit} isItemRemovalEnabled={item => item.uuid !== authentication.currentUser.uuid} />
              <TablePagination currentPage={result.page + 1} totalPages={result.totalPageCount} onPageClick={setCurrentPage} />
            </div>
          </div>
        </Route>
        <Route exact path={`${path}/:key`}>
          <PageTitle t={t} titleKey={model.uuid ? 'titles.edit' : 'titles.add'} />
          <UserEditForm t={t} model={model} availableRoles={availableRoles} onChange={handleChange} onSubmit={handleSubmit}>

            <div className="col-sm-6 col-xs-12 text-start">
              <button type="button" className="btn btn-danger" onClick={gotoList}>{t('common:actions.cancel')}</button>
            </div>
          </UserEditForm>
        </Route>
      </Switch>
    </section>
  )
}

export default withTranslation('userManagement')(UserManagement)
